<template>
  <div class="@container/card flex">
    <div
      class="flex grow flex-col items-stretch rounded-2xl shadow"
      :class="{
        '@xl/card:shadow-xl @xl/card:flex-row': !$slots.footer,
      }"
      >
      <div
        class="flex items-center justify-between rounded-t-2xl border-solid border border-white  transition"
        :class="{
          'border-sky-50 bg-sky-100': props.color === 'sky',
          'border-white bg-slate-50': props.color === 'slate',
          'pl-6': $slots.toggle,
          'opacity-50': props.disabled,
          '@xl/card:flex-col @xl/card:justify-center @xl/card:rounded-r-none @xl/card:rounded-l-2xl @xl/card:pl-0': !$slots.footer,
        }
          "
        aria-hidden="true">
        <div
          class="flex items-center gap-5 @sm/card:gap-7"
          :class="
            {
              'w-full justify-evenly @xl/card:justify-center': !$slots.footer && !$slots.toggle || $slots.footer && !$slots.toggle,
              'justify-center': !$slots.footer && $slots.toggle,
              '@xl/card:h-full @xl/card:flex-col @xl/card:gap-[12%]': !$slots.footer
            }
          "
          >
          <div v-for="index in 5"
            :key="index"
            class="-translate-y-1/3 flex-col items-center -space-y-1.5 "
            :class="[
              index === 5 ? 'hidden @xl/card:flex' : 'flex',
              {
                '@xl/card:translate-y-0 @xl/card:-translate-x-1/3 @xl/card:flex-row @xl/card:space-y-0 @xl/card:-space-x-1.5': !$slots.footer
              }
            ]">
            <div
              class="relative h-8 w-[4px] rounded-full bg-linear-to-b from-slate-50 to-slate-600 shadow-[0_2px_5px_#00000022] "
              :class="{
                '@xl/card:h-[5px] @xl/card:w-8': !$slots.footer
              }">
            </div>
            <div class="aspect-square w-2.5 rounded-full bg-slate-500 shadow-[0_1px_2px_#000000bb_inset]">
            </div>
          </div>
        </div>

        <div v-if="$slots.toggle"
          class="flex grow cursor-pointer items-center justify-end gap-2 py-3 px-4 text-sm"
          :class="{
            '@xl/card:hidden': !$slots.footer
          }"
          >
          <slot name="toggle"></slot>
        </div>
      </div>
      <div aria-hidden="true"
        class="h-px bg-slate-300"
        :class="{
            'opacity-50': props.disabled,
            '@xl/card:h-auto @xl/card:w-px': !$slots.footer
        }"></div>
      <div
        class="bg-dots relative flex grow grid-cols-3 flex-col items-stretch overflow-hidden rounded-b-2xl border border-solid border-white bg-slate-100"
        :class="{
          '@xl/card:grid @xl/card:rounded-r-2xl @xl/card:rounded-l-none': !$slots.footer
        }">
        <div
          class="col-span-1 flex flex-col items-start justify-center border border-solid border-white bg-linear-to-br from-white/60 to-white/90 py-6 px-6 shadow-lg"
          :class="{
            'opacity-50': props.disabled,
            '@4xl/card:px-12': !$slots.footer
        }"
          >
          <vx-badge class="mb-3"
            size="xs"
            color="slate">
            <slot name="type"></slot>
          </vx-badge>

          <h1
            class="mb-1.5 text-lg text-slate-700 font-extrabold leading-tight"
            :class="{
              '@2xl/card:text-2xl @2xl/card:leading-none': !$slots.footer
            }"
          >
            <slot name="title"></slot>
          </h1>

          <p v-if="props.basedOn"
            class="mb-2 text-xs text-slate-400">
            Based on: {{ props.basedOn }}
          </p>

          <div
            class="text-sm leading-snug text-slate-500"
            :class="{
              '@2xl/card:text-base': !$slots.footer
            }"
          >
            <slot name="description"></slot>
          </div>

          <div v-if="$slots.toggle" class="mt-4 hidden flex-col items-start"
            :class="{
              '@xl/card:flex': !$slots.footer
            }"
          >
            <div class="-ml-3 flex cursor-pointer items-center gap-2 py-3 px-3">
              <slot name="toggle"></slot>
            </div>
          </div>
        </div>
        <div class="col-span-2 flex grow @container"
            :class="{
                'opacity-50': props.disabled
            }">
          <div
            class="flex relative grow flex-col items-center justify-center px-6 py-6"
            :class="{
              '@lg/card:px-14 @xl/card:min-h-[350px] @xl/card:px-12 @xl/card:py-20': !$slots.footer
            }"
            >
            <slot />
          </div>
        </div>
        <div v-if="$slots.footer"
          class="p-4 bg-white backdrop-blur-sm"
          style="box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.08);">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { VxBadge } from '@voxie/frontend-components'

const props = defineProps({
  basedOn: {
    type: String,
  },
  color: {
    type: String,
    default: 'slate',
  },
  disabled: {
    type: Boolean,
    default: false,
  }
})

</script>

<style scoped>
.bg-dots {
  background-image: radial-gradient(rgba(0, 0, 0, 0.08) 1.5px, transparent 0);
  background-size: 24px 24px;
  background-position: 50% 50%;
}
</style>
